import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface Backdrop {
  visible: boolean;
  message?: string;
}


const initialState = {
  visible: false,
  message: "",
} as Backdrop;

const backdropSlice = createSlice({
  name: "backdrop",
  initialState,
  reducers: {
    showBackdrop: (state, action: PayloadAction<string | undefined>) => {
      state.visible = true;
      state.message = action?.payload || "";
    },
    hideBackdrop: (state) => {
      state.visible = false;
    },
  },
});

export const { showBackdrop, hideBackdrop } = backdropSlice.actions;

export default backdropSlice.reducer;
